export const ADMIN_COLORS = {
  accent: 'var(--admin-accent)',
  accentHover: 'var(--admin-accent-hover)',
  accentActive: 'var(--primary-800)',
  accentSoft: 'var(--admin-accent-soft)',
  accentRing: 'var(--admin-accent-ring)',
  accentDisabled: 'var(--primary-300)',
  surface: 'var(--admin-surface)',
  canvas: 'var(--admin-canvas)',
  headBg: 'var(--admin-head-bg)',
  hover: 'var(--admin-hover)',
  segmentBg: 'var(--admin-segment-bg)',
  border: 'var(--admin-border)',
  borderStrong: 'var(--admin-border-strong)',
  divider: 'var(--admin-divider)',
  text: 'var(--admin-text)',
  textSecondary: 'var(--admin-text-secondary)',
  textMuted: 'var(--admin-text-muted)',
  textFaint: 'var(--admin-text-faint)',
  danger: 'var(--admin-danger)',
  dangerSoft: 'var(--admin-danger-soft)',
  dangerBorder: 'var(--admin-danger-border)',
  success: 'var(--admin-success)',
  successSoft: 'var(--admin-success-soft)',
  successBorder: 'var(--admin-success-border)',
  warning: 'var(--admin-warning)',
  warningSoft: 'var(--admin-warning-soft)',
  warningBorder: 'var(--admin-warning-border)',
  scrollbar: 'var(--admin-scrollbar)',
  shadowPop: 'var(--admin-shadow-pop)',
} as const;
